export const getNormalizedPhone = (phone: string): string =>
  phone.replace(/[^\d|]/g, "");
